import React from "react";
import { FiX } from "react-icons/fi";
import "./UploadFontModal.css";

const UploadFontModal = ({
  handleCancelUpload,
  fontToUpload,
  handleConfirmUpload,
}) => {
  const handleNo = () => {
    handleCancelUpload();
  };

  const handleConfirm = () => {
    handleConfirmUpload(fontToUpload);
  };

  return (
    <div className="ufm-root" role="dialog" aria-modal="true">
      <div className="ufm-overlay" onClick={handleNo} />
      <div className="ufm-panel">
        <button
          type="button"
          className="ufm-close"
          onClick={handleNo}
          aria-label="Close"
        >
          <FiX size={16} strokeWidth={2.25} />
        </button>

        <div className="ufm-header">
          <h2 className="ufm-title">Please confirm the following</h2>
          <p className="ufm-copy">
            By uploading my own custom font, I acknowledge that I own{" "}
            <strong className="ufm-filename">{fontToUpload?.name}</strong> or
            have the right to use it for my intended purposes.
          </p>
        </div>

        <div className="ufm-actions">
          <button type="button" className="ufm-btn ufm-btn--cancel" onClick={handleNo}>
            Cancel
          </button>
          <button
            type="button"
            className="ufm-btn ufm-btn--confirm"
            onClick={handleConfirm}
          >
            Yes, upload it
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadFontModal;
